import { Grid, IconButton, Tooltip } from "@mui/material";
import { PictureAsPdf, InsertDriveFile, TableChart } from "@mui/icons-material";

const ReportDownloadIcons = ({ onDownloadCSV, onDownloadPDF, onDownloadExcel }) => (
  <Grid
    item
    xs={12}
    md={6}
    sx={{
      display: "flex",
      justifyContent: { xs: "center", md: "flex-end" },
      alignItems: "center",
      gap: 2, // Space between icons
    }}
  >
    <Tooltip title="Download as PDF" arrow>
      <IconButton
        onClick={onDownloadPDF}
        sx={{
          color: "red",
          backgroundColor: "rgba(255, 0, 0, 0.1)", // Light red background
          border: "2px solid rgba(255, 0, 0, 0.3)", // Border on idle
          borderRadius: "15px", // Soft rounded square
          transition: "0.3s",
          backdropFilter: "blur(5px)", // Glassmorphism effect
          "&:hover": {
            backgroundColor: "red",
            color: "white",
            boxShadow: "0px 4px 15px rgba(255, 0, 0, 0.7)", // Neon glow effect
            transform: "scale(1.1)", // Slightly enlarge on hover
          },
        }}
      >
        <PictureAsPdf fontSize="medium" /> {/* Reduced icon size */}
      </IconButton>
    </Tooltip>

    <Tooltip title="Download as Excel" arrow>
      <IconButton
        onClick={onDownloadExcel}
        sx={{
          color: "green",
          backgroundColor: "rgba(0, 128, 0, 0.1)",
          border: "2px solid rgba(0, 128, 0, 0.3)",
          borderRadius: "15px",
          transition: "0.3s",
          backdropFilter: "blur(5px)",
          "&:hover": {
            backgroundColor: "green",
            color: "white",
            boxShadow: "0px 4px 15px rgba(0, 128, 0, 0.7)",
            transform: "scale(1.1)",
          },
        }}
      >
        <TableChart fontSize="medium" />
      </IconButton>
    </Tooltip>

    <Tooltip title="Download as CSV" arrow>
      <IconButton
        onClick={onDownloadCSV}
        sx={{
          color: "blue",
          backgroundColor: "rgba(0, 0, 255, 0.1)",
          border: "2px solid rgba(0, 0, 255, 0.3)",
          borderRadius: "15px",
          transition: "0.3s",
          backdropFilter: "blur(5px)",
          "&:hover": {
            backgroundColor: "blue",
            color: "white",
            boxShadow: "0px 4px 15px rgba(0, 0, 255, 0.7)",
            transform: "scale(1.1)",
          },
        }}
      >
        <InsertDriveFile fontSize="medium" />
      </IconButton>
    </Tooltip>
  </Grid>
);

export default ReportDownloadIcons;
